import React from "react";

import type { FC } from "react";

type Props = {
  size?: number;
};

export const CheckIcon: FC<Props> = (props) => {
  const { size = 20 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M16.475 4.19232L17.6417 5.35898L7.025 15.9757L2.35833 11.309L3.525 10.1423L7.025 13.6423L16.475 4.19232ZM16.475 1.83398L7.025 11.284L3.525 7.78399L0 11.309L7.025 18.334L20 5.35898L16.475 1.83398Z"
        fill="black"
      />
    </svg>
  );
};
